class ConfiguratorRugs {
    cylindo_mapping = {
        'coolgrey7460': 'RUG_LA_7460_COOLGREY', // Los Angeles 7460 (Cool grey) / Los Angeles
        'darkgrey3250': 'RUG_LA_3250_DARKGREY', // Los Angeles 3250 (Dark grey) / Los Angeles
        'darknougat1120': 'RUG_LA_1120_DARKNOUGAT', // Los Angeles 1120 (Dark Nougat) / Los Angeles
        'lightbeige1080': 'RUG_LA_1080_LIGHTBEIGE', // Los Angeles 1080 (Light Beige) / Los Angeles
        'mediumgrey3140': 'RUG_LA_3140_MEDIUMGREY', // Los Angeles 3140 (Medium Grey) / Los Angeles
        'softgreige3050': 'RUG_LA_3050_SOFTGREIGE', // Los Angeles 3050 (Soft Greige) / Los Angeles

        // Adding missing mappings for HEMSEDAL rugs
        'taupe2300': 'RUG_HEMSEDAL_2300_MOLE', // Hemsedal 2300 (Taupe)
        'grey2500': 'RUG_HEMSEDAL_2500_GREY', // Hemsedal 2500 (Grey)

        // Adding missing mappings for TRYSIL rugs
        'cream1120': 'RUG_TRYSIL_1120_OFFWHITE', // Trysil 1120 (Cream/Off white)
        'mistygrey1210': 'RUG_TRYSIL_1210_LIGHTGREY', // Trysil 1210 (Misty Grey/Light grey)
        'anthracite1230': 'RUG_TRYSIL_1230_GREY', // Trysil 1230 (Anthracite/Grey)
        'charcoal1250': 'RUG_TRYSIL_1250_DARKGREY', // Trysil 1250 (Charcoal/Dark grey)

        // Old/existing mappings
        'brown': 'RUG_HEMSEDAL_2300_MOLE', // Hemsedal 2300 (Mole) / Hemsedal
        'darkbrown': 'RUG_HEMSEDAL_2500_GREY', // Hemsedal 2500 (grey) / Hemsedal

        'beige': 'RUG_TRYSIL_1120_OFFWHITE', // Trysil 1120 (off white) / Trysil
        'lightgrey': 'RUG_TRYSIL_1210_LIGHTGREY', // Trysil 1210 (light grey) / Trysil
        'grey': 'RUG_TRYSIL_1230_GREY', // Trysil 1230 (grey) / Trysil
        'darkgrey': 'RUG_TRYSIL_1250_DARKGREY', // Trysil 1250 (dark grey) / Trysil
    };

    constructor() {
        this.id = 'rugs';
        this.cache = {'data': [], 'products': {}};
        this.buyables = {};

        this.selectors = [
            'rugs'
        ];

        this.sizes = bed_configuration.sizes;

        //configurator.initSelector(this);
        configurator.addSelectorItem(this.id);
    }

    async refresh(selector) {
        await this.loadItems(configurator.selection.size);
        this.populateItems();
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    async loadItems(size) {
        const size_arr = size.split('x');
        const is_double = size_arr[0] > 140 ? true : false;
        let carpet_size = null;

        // TODO / HACK
        if (!is_double && !bed_configuration.base.includes("vindobed")) {
            // No rugs for single beds
            delete configurator.selection['rugs'];
        }

        // Fetch products only if not already loaded
        if (this.cache.data.length == 0) {
            this.cache.data = await configurator.loadProductData('configurator-rugs', [], []);
        }

        this.cache.products = {};

        switch (bed_configuration.type) {
            case 'bedframe':
            carpet_size = configurator.selection.nightstands != null ? [360, 260] : [300, 260];
            break;

            case 'floating':
            carpet_size = configurator.selection.nightstands != null ? [310, 260] : [280, 260];
            if (bed_configuration.base.includes("vindobed")) {
                carpet_size = !is_double ? [190, 260] : (configurator.selection.nightstands != null ? [310, 260] : [280, 260]);
                if (configurator.selection.headboards != null && is_double) { carpet_size[1] = 273; }
            }
            break;

            default:
            carpet_size = configurator.selection.nightstands != null ? [300, 260] : [250, 260];
            break;
        }

        for (const product of this.cache.data) {
            if (!is_double && !bed_configuration.base.includes("vindobed")) {
                continue;
            }

            for (const variant of product.variants) {
                // Filter variants on size (Vindö)
                if (bed_configuration.type == 'floating' && variant.option1 != carpet_size.join('x')) { continue; }
                if (bed_configuration.type != 'floating' && variant.option1 != carpet_size.join('x')) { continue; }

                // Skip variants with price 0 when e-commerce is enabled
                if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                // Skip if SKU is globally excluded
                if (bed_configuration.excluded_skus_global_set && bed_configuration.excluded_skus_global_set.has(variant.sku)) {
                    console.log(`Rug SKU ${variant.sku} for product ${product.productid} excluded globally.`);
                    continue;
                }

                const group_label = product.title +" "+ variant.option1;
                let lbl = bed_configuration.type == 'floating' ? variant.option2 : variant.option2;
                let variant_handle = lbl.toLowerCase().replace(/\s/g, '').replace(/\//g, '-');

                //product.title = bed_configuration.type == 'floating' ? variant.option2 : variant.option2;
                //product.productid = product.title.toLowerCase().replace(/\s/g, '').replace(/\//g, '-');

                this.cache.products[variant_handle] = configurator.variantToItem(product, variant);
                this.cache.products[variant_handle].group_by = group_label;
                this.cache.products[variant_handle].id = variant_handle;
                this.cache.products[variant_handle].label = bed_configuration.type == 'floating' ? variant.option2 : variant.option2;

                if (variant_handle in this.cylindo_mapping) {
                    this.cache.products[variant_handle].thumbnail = configurator.getSwatch(this.cylindo_mapping[ variant_handle ], 'CARPET COLOR'); //'0,0,472,336'
                }
            }
            console.log(this.cache.products);
        }
    }

    populateItems() {
        this.items = this.cache.products;

        const allow_none = bed_configuration.type != 'floating';

        configurator.renderSelector(this.id, Object.values(this.items), {
            'thumbnails': true,
            'allow_none': allow_none,
        });
    }

    isSoldOut() {
        return false;
    }

    getPriceData(priceData) {
        if (configurator.selection.rugs) {
            const item = this.items[ configurator.selection.rugs ];

            if (item != null) {
                priceData.total += item.price ?? 0;
                priceData.skus.push(...item.skus);
                priceData.ids.push(...item.ids);
            }
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate rug config ==============
        if (configurator.selection.rugs != null && configurator.selection.rugs in this.cylindo_mapping) {
            specs.features['CARPET COLOR'] = this.cylindo_mapping[ configurator.selection.rugs ];
        }
    }
}
